export const colors = {
  black: '#000',

  // Toss Style Light Theme (Grey + White)
  background: {
    primary: '#FFFFFF',
    secondary: '#F7F8FA',
    tertiary: '#F2F3F5',
    elevated: '#FFFFFF',
    canvas: '#F2F3F5'
  },
  text: {
    primary: '#191F28',
    secondary: '#4E5968',
    tertiary: '#8B95A1'
  },
  border: {
    default: '#E5E8EB',
    subtle: '#F2F3F5',
    focus: '#191F28'
  },
  accent: {
    primary: '#191F28',
    primaryHover: '#4E5968'
  },

  // Badge colors
  badge: {
    pro: { background: '#FFFFFF', text: '#191F28' },
    starter: { background: '#FFFFFF', text: '#4E5968' },
    free: { background: '#FFFFFF', text: '#8B95A1' },
    new: { background: '#FFFFFF', text: '#191F28' },
    video: { background: '#FFFFFF', text: '#4E5968' },
    game: { background: '#FFFFFF', text: '#4E5968' }
  },

  // Card states
  card: {
    default: '#FFFFFF',
    hover: '#F7F8FA',
    exported: '#F7F8FA'
  }
};
